export interface Audio {
  id: string;
  type: 'full' | 'highlight';
  url: string;
}

export interface Music {
  id: string;
  audios: Audio[];
  source: 'library' | 'generation';
}

export interface GenerationInfo {
  prompt: string;
  lyrics: string | null;
}

export interface PlayerTrack {
  url: string;
  title: string;
  generation: GenerationInfo | null;
  startTime?: number;
  endTime?: number;
}

export const isSameTrack = (a: PlayerTrack, b: PlayerTrack): boolean =>
  a.url === b.url && a.startTime === b.startTime && a.endTime === b.endTime;
